import {
    IIdentityResultsResponse,
    IIdentityStatusResponse,
    IYotiSessionStartResponse,
} from '@/types/types';
import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';

const makeIdentityVerificationService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getStatus: async (requestToken: string): Promise<IIdentityStatusResponse> => {
            const res = await fetcher.get(`/${requestToken}/identity`, { disableRedirects: true });
            const data = (await res.json()) as Promise<IIdentityStatusResponse>;
            return data;
        },
        updateYotiSession: async (
            requestToken: string,
            sessionId: string,
        ): Promise<IIdentityResultsResponse> => {
            const res = await fetcher.post(
                `/${requestToken}/results`,
                JSON.stringify({ sessionId }),
                { disableRedirects: true },
            );
            const data = (await res.json()) as Promise<IIdentityResultsResponse>;
            return data;
        },
        startYotiSession: async (
            requestToken: string,
            completeOnMobile: boolean,
            mockSuccessfulSessionResults = false,
        ): Promise<IYotiSessionStartResponse> => {
            const res = await fetcher.post(
                `/${requestToken}/identity`,
                JSON.stringify({ completeOnMobile, mockSuccessfulSessionResults }),
                { disableRedirects: true },
            );
            const data = (await res.json()) as Promise<IYotiSessionStartResponse>;
            return data;
        },
    };
};

export const identityVerificationService = makeIdentityVerificationService(
    config.api.url.verification,
);
